import React from "react";

export default function Footer() {
    return (
        <div className="fixed-bottom shadow-sm">
            <span className="footer">Breadcrumbs</span> by{" "}
            <a href="https://github.com/jjayeon">@jjayeon</a>,{" "}
            <a href="https://github.com/hankc97">@hankc97</a>, and{" "}
            <a href="https://github.com/mgsium">@mgsium</a>
        </div>
    );
}
